import { CoreButton, CoreSidebarRight } from '@components'
import ActivitiesIcon from '@images/expenses/report-activities.svg?react'
import { ReportActionBadge } from '@views/expenseManagement/components'
import { tr } from 'mmfintech-commons'
import { useState } from 'react'
import { ActivitiesSidebar } from './ActivitiesSidebar'

export const ReportActivitiesButton = ({ reportId }) => {
  const [showActivities, setShowActivities] = useState<boolean>(false)
  const handleOpenActivities = () => setShowActivities(true)

  return (
    <>
      <CoreButton
        variation='tertiary'
        text={tr('FRONTEND.REPORTS.HISTORY_LABEL.SHOW_HISTORY', 'Show Activity')}
        LeftIcon={<ActivitiesIcon />}
        data-test='button-history'
        onClick={handleOpenActivities}
        size='large'
      />
      <CoreSidebarRight
        header={<ReportActionBadge reportId={reportId} />}
        content={<ActivitiesSidebar reportId={reportId} />}
        visible={showActivities}
        onClose={() => setShowActivities(false)}
        options={{
          size: 'auto',
          closeOnClickOutside: true
        }}
      />
    </>
  )
}
